import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { ThemeContext } from './ThemeContext';

const Header = () => {
  const { isDarkMode, toggleDarkMode, logo } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  // const { logo } = useContext(ThemeContext);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className={`header ${isDarkMode ? 'dark' : ''}`}>
      <Link to='/'><img className='psg-logo' src={logo}></img></Link>
      <div className="rhs-buttons">
      <label className='switch'>
        <input type="checkbox" onClick={toggleDarkMode}></input>
        <span class="slider round"></span>
      </label>
      <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleDropdown}>
        <div className="bar"></div>
      </div>
      <div className={`dropdown ${isOpen ? 'show' : ''}`}>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </div>
      </div>
    </header>
  );
};

export default Header;
